import {clientGetWrapper} from "../api/Api";
import {GET_ALL_ADVERTISERS} from "../common/constants/routes";

export const getAllAdvertisers = () => {
    return clientGetWrapper(GET_ALL_ADVERTISERS);
}